var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExternalLinkIcon = function SvgExternalLinkIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.482 6.527V10.5H1.5V4.518h4.08",
    fill: "none",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.766 1 4.199 2.545l1.315 1.309-2.81 2.808L5.392 9.35l2.724-2.723 1.31 1.31L11 6.391V1H5.766zm-.645.99 4.873.014.024 4.885L8.199 5.07 5.32 7.95 4.09 6.722l2.883-2.88L5.12 1.99z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExternalLinkIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNy40ODIgNi41Mjc1djMuOTcyNWgtNS45ODJ2LTUuOTgyaDQuMDc5NSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJtNS43NjU2IDEtMS41NjY0IDEuNTQ0OSAxLjMxNDUgMS4zMDg2LTIuODEwNSAyLjgwODYgMi42ODk1IDIuNjg3NSAyLjcyNDYtMi43MjI3IDEuMzEwNSAxLjMxMDUgMS41NzIzLTEuNTQ2OXYtNS4zOTA2aC01LjIzNDR6bS0wLjY0NDUzIDAuOTkwMjMgNC44NzMgMC4wMTM2NzIgMC4wMjM0MzcgNC44ODQ4LTEuODE4NC0xLjgxODQtMi44Nzg5IDIuODc4OS0xLjIzMDUtMS4yMjY2IDIuODgyOC0yLjg3ODktMS44NTE2LTEuODUzNXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";